<template>

  <div class="commmonmokuaic">




    <div class="suodingtip" :style="suodingtipcss">
      <div class="dd">请锁定竖屏观看<br>如果还不行请刷新页面重试</div>
    </div>
    <transition name="fade">
      <div class="showcontainervue  sharetipcontainer" v-show="sharetipcontainercss">
        <div class="bantouminghei" v-tous="closesharetip"></div>
        <img :src="resourcepath + '/images/sharetip.png'" class="sharetip">
        <div class="sharetipwz">{{ sharewz }}</div>
      </div>
    </transition>
    <div class="showcontainervue" style="z-index:9999" v-show="isshowjiazai">

      <img :src="resourcepath + '/images/jiazai.svg'" alt="" class="jiazaigif">
    </div>
    <transition name="fade">
      <div class="morentanchuang" v-show="morentanchuangcss">
        <div class="bantouminghei" style="opacity: 0.2"></div>
        <div class="chuang">
          <div class="chuangtitile" vartype="chuangtitle">{{ chuangtitle }}</div>
          <div class="chuangbtn">确认</div>
        </div>
      </div>
    </transition>


  </div>
</template>
<script>
import { mapState } from "vuex";
import { resourcepath } from "@/commonjs/commonfn.js";
import store from "@/store/";
import loadui from "./loadui.vue";
export default {
  components: { loadui },
  name: "commonmokuai",
  data() {
    return {
      resourcepath: resourcepath,
    };
  },
  mounted() { },
  methods: {
    fun() {
      //test1函数没有参数，默认传递 $event
      eval(this.fn);
      store.commit("morentanchuangset", [0, "", ""]);
    },
    closesharetip() {
      store.commit("sharetipcontainerset", 0);
    },
  },
  computed: {
    ...mapState([
      "suodingtipcss",
      "yujiazaicss",
      "sharetipcontainercss",
      "morentanchuangcss",
      "chuangtitle",
      "fn",
      "jindu",
      "starcss",
      "isalljiazai",
      "isplaybgmusic",
      "isshowjiazai",
      "sharewz",
    ]),

  },
};
</script>
<style scoped>
.p1_1jiazai {
  width: 34%;
  position: absolute;
  left: 33%;
  top: 45%;
}

.jindubgcontainer {
  width: 33%;
  height: 2px;
  position: absolute;
  left: 33.1%;
  top: 55%;
}

.jindubgcontainer .bg {
  width: 0%;
  background: #e6ccb4;
}
</style>


// WEBPACK FOOTER //
// src/components/commonmokuai.vue